export const containerStyle = {
  marginTop: '24px',
  width: '100%',
  flex: 1,
};

export const defaultCenter = {
  lat: 40.0150,
  lng: -105.2705,
};
